import agGridThemeClass from '../../vendor/ag-grid/agGridThemeClass';

const getAgGridThemeClass = {
  methods: {
    getThemeClass: () => agGridThemeClass(),
  },
};
export default getAgGridThemeClass;
